import { EPlanningColumns, TPlanningTab, TSearchPlanningTab } from './planning.type'

export const ALL_PLANNING_TAB_ID = 0

export const DEFAULT_COLUMNS: EPlanningColumns[] = [
  EPlanningColumns.ID,
  EPlanningColumns.PATIENT,
  EPlanningColumns.MED_EVENT,
  EPlanningColumns.MEDICAL_STAFF_MEMBER,
  EPlanningColumns.CONVOCATION,
  EPlanningColumns.ACTIONS,
]

export const isAllPlanningTab = (tab: TPlanningTab | TSearchPlanningTab): tab is TSearchPlanningTab =>
  tab.id === ALL_PLANNING_TAB_ID

// Only the columns of the "all" tab can be customized, everything else is fixed
export const buildAllPlanningTab = (savedAllTab?: TPlanningTab): TSearchPlanningTab => ({
  id: ALL_PLANNING_TAB_ID,
  relativeRangeOfDays: [-3, 3],
  columns: savedAllTab?.columns || DEFAULT_COLUMNS,
  medEventIdsFilter: undefined,
  medicalStaffMemberIdsFilter: undefined,
})
